import React, { useState } from 'react';
import SortButton from '../../UI/SortButton';
import classes from '../index.module.scss';

const FederalContactsTableHeader = () => {
  const [sortedBy, setSortedBy] = useState({
    posted_date: null,
    title: null,
    agency: null
  });

  return (
    <tr>
      <SortButton 
        name="Date Posted"
        sortBy="posted_date"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <SortButton 
        name="Opportunity/Contract"
        sortBy="title"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <th className={classes.Small_Width}>
        Type
      </th>
      <SortButton 
        name="Agency"
        sortBy="agency"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
    </tr>
  )
}

export default FederalContactsTableHeader;